module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/7b4d76cb3be69c42bb81fa43aac08d10.png";